import {useWatch} from 'react-hook-form'
import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

export const useUsage = () => {
  const {control, setValue, trigger, formState: {defaultValues}} = useOrderProcessFormContext()
  const usageConfiguration = useFieldConfigurationContext('concreteUsage')

  const usage = useWatch({name: 'concreteUsage', control})
  const defaultUsage = defaultValues?.concreteUsage

  const setConcreteUsage = (concreteUsage?: string) => {
    setValue('concreteUsage', concreteUsage)
    void trigger('concreteUsage');
  }

  return {
    ...usageConfiguration,
    usage,
    defaultUsage,
    setConcreteUsage
  }
}
